import { render, staticRenderFns } from "./LayoutSelector.vue?vue&type=template&id=d53d28a8&scoped=true"
import script from "./LayoutSelector.vue?vue&type=script&lang=js"
export * from "./LayoutSelector.vue?vue&type=script&lang=js"
import style0 from "./LayoutSelector.vue?vue&type=style&index=0&id=d53d28a8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53d28a8",
  null
  
)

export default component.exports